"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var utils_1 = require("../utils");
var NotificationItem = function (_a) {
    var item = _a.item;
    var isStringified = function (str) {
        try {
            return JSON.parse(str);
        }
        catch (_a) {
            return str;
        }
    };
    var parsedIssue = __assign(__assign({}, item), { message: isStringified(item.message), messageDetails: isStringified(item.messageDetails) });
    var issueMessages = (0, utils_1.notifications)(parsedIssue);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ direction: "row", flexWrap: "wrap", sx: {
            paddingX: '2.8rem',
            borderLeftColor: (0, utils_1.statusColors)(item.severity),
            borderLeftStyle: 'solid',
            borderLeftWidth: '0.4rem',
            paddingY: '2.8rem',
            '&:last-child': {
                borderBottomLeftRadius: '1rem',
            },
        } }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    color: (0, utils_1.statusColors)(item.severity),
                    backgroundColor: (0, utils_1.statusColors)(item.severity),
                    borderRadius: '50%',
                    width: '4.8rem',
                    height: '4.8rem',
                    marginRight: '2.8rem',
                    top: '2.4rem',
                    right: '2.4rem',
                } }, { children: (0, utils_1.ratingIcons)(item.severity) })), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ spacing: "0.4rem", flex: 1 }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "p", sx: { fontWeight: 'medium' } }, { children: issueMessages.message })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "p", sx: { color: 'primary.400' } }, { children: issueMessages.details })), (0, jsx_runtime_1.jsxs)(material_1.Stack, __assign({ spacing: "0.4rem", direction: "row" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "p", variant: "bodySmall", sx: { color: 'primary.400' } }, { children: (0, utils_1.dateLocalizer)(item.timeCreated) })), (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ component: "p", variant: "bodySmall", sx: { color: 'primary.400' } }, { children: (0, utils_1.timeLocalizer)(item.timeCreated) }))] }))] }))] })));
};
var NotificationListMini = function (_a) {
    var data = _a.data;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(material_1.Divider, { orientation: "horizontal", flexItem: true }), (0, jsx_runtime_1.jsx)(material_1.Stack, __assign({ divider: (0, jsx_runtime_1.jsx)(material_1.Divider, { orientation: "horizontal", flexItem: true }) }, { children: data.map(function (item) {
                    return (0, jsx_runtime_1.jsx)(NotificationItem, { item: item }, item.machine);
                }) })), (0, jsx_runtime_1.jsx)(material_1.Divider, { orientation: "horizontal", flexItem: true })] }));
};
exports.default = NotificationListMini;
